import { MeshProps } from '@react-three/fiber'

interface Props extends MeshProps {
  intensity?: number
}

export const DirectionalLight = ({
  position,
  intensity,
}: Props): JSX.Element => {
  return (
    <mesh position={position}>
      <directionalLight
        shadow-camera-left={-20}
        shadow-camera-right={20}
        shadow-camera-top={15}
        shadow-camera-bottom={-15}
        shadow-radius={1}
        shadow-bias={-0.00007}
        castShadow
        intensity={intensity}
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
      />
    </mesh>
  )
}
